export class PlayerComparisonRepository {
    public static setChangeNotification(key: string, callback: () => void) {
        listeners[key] = callback;
    }

    public static getComparisons(): string[] {
        return idsStorage.getValues();
    }

    public static addComparison(id: string): void {
        const currentValues = idsStorage.getValues();
        if (!currentValues.includes(id)) {
            currentValues.push(id);
            idsStorage.setValues(currentValues);
            this.notifyChange();
        }
    }

    public static isInComparisonList(id: string){
        const currentValues = idsStorage.getValues();
        return currentValues.includes(id);
    }

    public static removeComparison(id: string): void {
        const currentValues = idsStorage.getValues();
        if (currentValues.includes(id)) {
            const valuesWithoutId = currentValues.filter((x) => x !== id);
            idsStorage.setValues(valuesWithoutId);
            this.notifyChange();
        }
    }

    public static clearAllComparisons(): void {
        const currentValues = idsStorage.getValues();
        if (currentValues.length > 0) {
            idsStorage.setValues([]);
            this.notifyChange();
        }
    }

    private static notifyChange(): void {
        for (let key in listeners) {
            listeners[key]();
        }
    }
}

class StorageWrapper {
    private key: string;
    constructor(key: string) {
        this.key = key;
    }

    public getValues(): string[] {
        const savedValue = localStorage.getItem(this.key);
        return this.split(savedValue);
    }

    public setValues(values: string[]) {
        const valueToSave = this.join(values);
        localStorage.setItem(this.key, valueToSave);
    }

    private readonly separator: string = '|';
    private split(value: string): string[] {
        if (!value) {
            return [];
        }
        return value.split(this.separator);
    }
    private join(values: string[]): string {
        return values.join(this.separator);
    }
}
const idsStorage = new StorageWrapper('ndcMatchmakerComparisonIds');
const listeners: { [key: string]: () => void } = {};
